<script setup lang="ts">
import type { AdvancedDetectionFilters, DetectionFilters } from '@/types/filters/DetectionFilters'
import type { DetectionModel } from '@/types/models/DetectionModel'
import { DatePickerField, StackLayout } from '@rfc/rfc-components-library'
import moment from 'moment'

type Props = {
    filters?: Partial<AdvancedDetectionFilters & DetectionFilters>
}

const props = defineProps<Props>()
type Emits = {
    (e: 'change', value: Partial<AdvancedDetectionFilters & DetectionModel>): void
}
const emit = defineEmits<Emits>()

const handleStartAtChange = (value?: Date | null) => {
    const start_at = value ? moment(value).startOf('d').utc(true).toDate() : value
    const end_at =
        props.filters?.end_at && moment(props.filters?.end_at).isBefore(moment(value).startOf('d'))
            ? moment(start_at).endOf('d').utc(true).toDate()
            : props.filters?.end_at
    emit('change', {
        start_at,
        end_at
    })
}
</script>

<template>
    <StackLayout direction="column" :gap="12" class="w-full">
        <StackLayout :gap="8" class="w-full advanced-datepicker" isResponsiveSmallScreen>
            <DatePickerField
                :label="$t('detection.filters.startDate')"
                :modelValue="filters?.start_at"
                @change="handleStartAtChange"
                utc
                :max="moment().endOf('d').utc().toDate()"
                clearable
                class="w-full" />
            <DatePickerField
                :label="$t('detection.filters.endDate')"
                :modelValue="filters?.end_at"
                @change="
                    $emit('change', {
                        end_at: $event ? moment($event).endOf('d').utc(true).toDate() : undefined
                    })
                "
                utc
                :min="moment(filters?.start_at).startOf('d').utc().toDate()"
                :max="moment().endOf('d').utc().toDate()"
                clearable
                class="w-full" />
        </StackLayout>
        <slot />
    </StackLayout>
</template>

<style scoped lang="scss">
.advanced-datepicker {
    & :deep(.dropdown-menu) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        max-height: unset;

        @media screen and (max-width: 1023px) {
            margin-top: 7vh;
        }
    }
}
</style>
